import { Directive, booleanAttribute, input } from '@angular/core';

/**
 * Vstupy ui-toggle-switch: stejné jako ui-checkbox bez `binary` (přepínač je vždy dvoustavový).
 * Seznam ui-checkbox se z něj odvozuje, aby se nerozešly; `hostDirectives` přijme jen staticky vyhodnotitelný výraz,
 * proto rozložení pole místo `filter`.
 */
export const ToggleSwitchFormControlDirectiveInputs = [
  'falseValue',
  'appearanceDisabled',
  'customTemplateItem',
  'alignToFields',
];

export const CheckboxFormControlDirectiveInputs = [...ToggleSwitchFormControlDirectiveInputs, 'binary'];

@Directive({
  selector: '[uiCheckboxFormControl]',
  standalone: true,
  host: { '[class.mt-0]': 'alignToFields()' },
})
export class CheckboxFormControlDirective {
  readonly falseValue = input<false | null>(null);

  readonly binary = input(true);

  readonly appearanceDisabled = input(false);

  readonly customTemplateItem = input<unknown | null>(null);

  /**
   * Přepínač nebo zaškrtávátko v řádku formuláře vedle polí s popiskem (ui-input, ui-select …): nad sebou nechá
   * prázdný řádek popisku místo horního okraje (mt-0 na hostiteli) a sám leží ve výšce pole, takže je svisle na středu
   * sousedního pole.
   */
  readonly alignToFields = input(false, { transform: booleanAttribute });
}
